import { render, staticRenderFns } from "./CategoryListTile.vue?vue&type=template&id=0fde7c04&"
import script from "./CategoryListTile.vue?vue&type=script&lang=ts&"
export * from "./CategoryListTile.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryListTile.vue?vue&type=style&index=0&id=0fde7c04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports